import { IExportPlugin, LayerType, PluginType } from '@/version-types';
import textLayerBehavior from './behavior';
import { TextLayer } from './domain';
import { ReplaceTextLayerHistory } from './domain/replacer';

export {
    FeatureChecker,
    loadTextMarkResource,
    PPTSaver,
    ResultCanvasCreator,
    createTextLayer,
    getTextMarkConfig,
    createTextContentsByArtText,
} from './utils';
export { getShapeTypeConfig } from './config';
export { TextLayer } from './domain';
export { type ArtTextCharacterConfig } from './domain/art-text';
export { default as SVGTextRenderer } from './view/svg-text-renderer';
export type {
    ShapeTextProps,
    TextEffectKind,
    TextEffectPreset,
    StrokeAdjustPayload,
    ShadowAdjustPayload,
    GlowAdjustPayload,
    BackgroundAdjustPayload,
    TextMarkStruct,
} from './types';

/**
 * 文本图层插件
 */
export const textLayerPlugin: IExportPlugin = {
    sort: 0,
    type: PluginType.LAYER,
    name: LayerType.TEXT_LAYER,
    createInstance({ identity }) {
        return [{ key: 'TextLayer', value: new TextLayer(identity) }];
    },
    createBehavior() {
        return textLayerBehavior;
    },
    createHistory({ identity }) {
        return [new ReplaceTextLayerHistory(identity)];
    },
};
